<template>
  <Multiselect
    :id="htmlId"
    v-model="valueHandler"
    label="value"
    trackBy="key"
    valueByPath="key"
    :options="usersToSelect"
    :disabled="isDisabled"
    :max="1"
  ></Multiselect>
</template>

<script>
import _ from 'lodash'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import { createDataTypeValue } from '../utils'

export default {
    name: 'LinkUserInput',
    components: {
        Multiselect,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            required: false,
            default: _ => createDataTypeValue(),
        },
        propertyType: {
            type: Object,
            required: true,
        },
        htmlId: {
            type: String,
            required: false,
            default: _ => null,
        },
        visibility: {
            type: Number,
            required: false,
            default: _ => 0,
        },
    },
    computed: {
        valueHandler: {
            get() {
                return _.get(this, 'value.value.value', null)
            },
            set(value) {
                if (_.size(value) === 0) {
                    this.$emit('delete')
                } else {
                    if (this.visibility === 0) {
                        this.$emit('input', createDataTypeValue(value))
                    }
                }
            },
        },
        usersToSelect() {
            return _.map(this.$store.getters.users, u => {
                return {
                    key: _.get(u, 'id'),
                    value: _.get(u, 'username'),
                }
            })
        },
        isDisabled() {
            console.info(this.visibility)
            if (this.visibility > 0) return true
            if (_.get(this, 'propertyType.settings.systags.author', false)) return true
            return false
        },
        isAuthor() {
            return _.get(this, 'propertyType.settings.systags.author', false)
        },
    },
    mounted() {
        const labelOptions = []
        if (this.isAuthor) {
            // if (this.value === null) {
            //     console.debug(`Because ${this.id} is tagged as AUTHOR setting value to current user`)
            //     this.$set(this, 'valueHandler', [this.$store.getters.currentUserId])
            // }
            labelOptions.push('autofilled')
            labelOptions.push('required')
        }
        this.$emit('labelOptions', labelOptions)
    },
}
</script>
